<template>
<div >
	<div class="damages-types-buttons">
		
		<div class="damage-type" @click="selectType('SCRATCH')" :class="{'selected': selected=='SCRATCH'}" >
			<div class="btn damage-scratch-bg">
				<i class="damage-icon damage-scratch-icon"></i>
			</div>
			<div class="text">RAYÓN</div>
		</div>
		<div class="damage-type" @click="selectType('DENT')" :class="{'selected': selected=='DENT'}" >
			<div class="btn damage-dent-bg">
				<i class="damage-icon damage-dent-icon"></i>
			</div>
			<div class="text">BOLLO</div>
		</div>
		<div class="damage-type" @click="selectType('MISSING')" :class="{'selected': selected=='MISSING'}" >
			<div class="btn damage-missing-bg">
				<i class="damage-icon damage-missing-icon"></i>
			</div>
			<div class="text">FALTANTE</div>
		</div>
		<div class="damage-type" @click="selectType('RIVEN')" :class="{'selected': selected=='RIVEN'}" >
			<div class="btn damage-riven-bg">
				<i class="damage-icon damage-riven-icon"></i>
			</div>
			<div class="text">RAJADURA</div>
		</div>
		<div class="damage-type" @click="selectType('OTHER')" :class="{'selected': selected=='OTHER'}" >
			<div class="btn damage-other-bg">
				<i class="damage-icon damage-other-icon"></i>
			</div>
			<div class="text">OTRO</div>
		</div>
		<div class="damage-type" @click="selectType('TOTAL')" :class="{'selected': selected=='TOTAL'}" >
			<div class="btn damage-total-bg">
				<i class="damage-icon damage-total-icon"></i>
			</div>
			<div class="text">DAÑO TOTAL</div>
		</div>
	</div>
</div>

</template>

<script>

export default {
	name: "inputDamageType",
	props:{
        context: {
            type: Object,
            required: true
        },
    },
	computed: {
        selected: {
            get: function() {
                return this.context.model || ''
            },
            set: function(newValue) {
                this.context.model = newValue;
            }
		},
	},
	methods:{
		selectType(type){
			this.selected = type
			this.$emit('input', this.selected)
		}
	}
}
</script>

<style scoped>
.damages-types-buttons{
	display: flex;
	justify-content: space-around;

}
.damages-types-buttons .damage-type{
	opacity: .6;
}
.damages-types-buttons .damage-type .btn{
	margin: 4px auto;
	padding: 0px;
	width: 48px;
    height: 48px;

}
.damages-types-buttons .damage-type .text{
	font-size: 10px;
	text-align: center;
}
.damages-types-buttons .damage-type.selected{
	opacity: 1;
}


</style>
